window.freestar = window.freestar || {};
freestar.queue = freestar.queue || [];
freestar.config = freestar.config || {};
freestar.config.enabled_slots = freestar.config.enabled_slots || [];
freestar.events = freestar.events || [];
freestar.debug = false;
